import { BANK_VERIFICATION_NUMBER_LENGTH } from "@zenith/data/constants";

export const setBvnValidations = (bvn: string) => {
  const hasError = false;
  const message = "";

  if (bvn === "") {
    return {
      hasError: true,
      message: "Bank Verification Number is required",
    };
  } else if (bvn.length < BANK_VERIFICATION_NUMBER_LENGTH) {
    return {
      hasError: true,
      message: "Bank Verification Number is not valid",
    };
  }

  return {
    hasError,
    message,
  };
};
